import React, { useContext, useEffect, useState } from "react";
import { Chip } from "@material-ui/core";
import { SettingsContext } from "../../context/Settings/SettingsContext";
import ModuleErrorBoundary from "../ModuleErrorBoundary";

// Identificador del OBJETO del contacto (TurnosIA, 2026-09-28): la patente en
// un taller, el nombre del animal en una veterinaria, el n° de serie en un
// service técnico. Va AL LADO del nombre porque el mostrador busca por eso —
// «los autos adentro del taller tienen patente, no nombre del dueño».
//
// Qué clave de la ficha es el identificador lo decide cada empresa en
// TurnosIA → Ajustes. Sin TurnosIA, sin config o sin valor: no se dibuja nada.
//
// ⚠ `turnosApi` se importa DINÁMICO (mismo motivo que `useTurnosChatAccess`):
// este componente vive en el bundle principal (cabecera del ticket, ficha del
// contacto) y un error a nivel de módulo de TurnosIA ahí dejaría WAIA en
// blanco. Además va dentro de un boundary `silent`: si falla, desaparece el
// chip y nada más.

const TTL_MS = 5 * 60 * 1000;
// La config de la empresa se pide UNA vez por sesión: si no configuró nada, no
// se pregunta por cada ticket que se abre.
let configPromise = null;
const porNumero = new Map(); // number → { at, promise }

export function invalidateContactIdentificador() {
  configPromise = null;
  porNumero.clear();
}

const loadApi = () =>
  import("../../pages/TurnosIA/hooks/useTurnosApi").then(m => m.turnosApi);

const fetchIdentificador = number => {
  if (!configPromise) {
    configPromise = loadApi()
      .then(api => api.get("/company/identificador-config"))
      .then(({ data }) => Array.isArray(data?.claves) && data.claves.length > 0)
      .catch(() => false);
  }
  const hit = porNumero.get(number);
  if (hit && Date.now() - hit.at < TTL_MS) return hit.promise;
  const promise = configPromise.then(activo => {
    if (!activo) return null;
    return loadApi()
      .then(api => api.get("/contacts/identificador", { params: { number } }))
      .then(({ data }) => data?.identificador || null)
      .catch(() => null);
  });
  porNumero.set(number, { at: Date.now(), promise });
  return promise;
};

const Identificador = ({ number, size }) => {
  const { getSetting } = useContext(SettingsContext);
  const habilitado = getSetting("turnosIAEnabled") === "true";
  const digits = String(number || "").replace(/\D/g, "");
  const [ident, setIdent] = useState(null);

  useEffect(() => {
    setIdent(null);
    if (!habilitado || !digits) return undefined;
    let alive = true;
    fetchIdentificador(digits).then(v => {
      if (alive) setIdent(v);
    });
    return () => {
      alive = false;
    };
  }, [habilitado, digits]);

  if (!ident) return null;
  return (
    <Chip
      size="small"
      variant="outlined"
      color="primary"
      label={`${ident.etiqueta}: ${ident.valor}`}
      style={{
        fontWeight: 700,
        letterSpacing: 0.5,
        maxWidth: size === "wide" ? 320 : 220,
        height: 22
      }}
    />
  );
};

const ContactIdentificador = props => (
  <ModuleErrorBoundary module="TurnosIA/identificador" variant="silent">
    <Identificador {...props} />
  </ModuleErrorBoundary>
);

export default ContactIdentificador;
